/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-18 07:18:23
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle, Link } from '@shopify/polaris';
import { URL } from 'src/constants/links';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import Congrat from 'src/assets/images/dashboard/congrat.png';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  handleChangeModal: Function
};

type ComposedProps = Props & WithI18nProps;

class ComingExpiredModal extends Component<ComposedProps> {
  render() {
    const { i18n, active, handleChangeModal, dayLeft } = this.props;
    let title = <span></span>;
    switch (dayLeft) {
      case 2: {
        title = (
          <span>{i18n.translate('AdminHTML.Subscription.ComingExpired.title_2DaysRemaining')}</span>
        );
        break;
      }
      case 1: {
        title = (
          <span>{i18n.translate('AdminHTML.Subscription.ComingExpired.title_1DayRemaining')}</span>
        );
        break;
      }
      default:
        title = (
          <span className="BC-Finish-trial">
            {i18n.translate('AdminHTML.Subscription.ComingExpired.title_Complete', {
              nt_image: <img className="icon" src={Congrat} alt="" />
            })}
          </span>
        );
    }

    return (
      <Modal
        open={active}
        onClose={() => handleChangeModal('')}
        title={title}
        primaryAction={{
          content: i18n.translate(
            `AdminHTML.Subscription.ComingExpired.${dayLeft === 0 ? 'subscribeNow' : 'subscribe'}`
          ),
          onAction: () => {
            handleChangeModal('go to subscription');
            history.push(routes.subscription.plan());
          }
        }}>
        <Modal.Section>
          <TextContainer>
            {dayLeft === 0 && (
              <p>{i18n.translate('AdminHTML.Subscription.ComingExpired.completeTrial')}</p>
            )}
            <p>
              {i18n.translate('AdminHTML.Subscription.ComingExpired.content', {
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.Subscription.ComingExpired.content_t1')}
                  </TextStyle>
                )
              })}
            </p>
            <p>
              <Link url={URL.SearchTrialDoc} external>
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Subscription.ComingExpired.whatHappenAfterTrial')}
                </TextStyle>
              </Link>
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(ComingExpiredModal);
